import moment from 'moment';
import Pagination from "../../utilities/Pagination"
import { SearchInput } from "../../components/search/Search";
import { allServicesCategories, allStatusListItems, allSubServices } from "../../data/CategoriesData";
import Requests from "./Components/RequestsTbl";
import { useTranslation } from 'react-i18next';
import ItemsToShow from "../../components/common/ItemsToShow";
import { useUserOrder } from "../../context/User/UserOrderContext";

export default function MyOrders() {
    const { loading, orderData,
        currentPage, setCurrentPage,
        searchQuery, setSearchQuery,
        setItemsLimit, itemsLimit } = useUserOrder();
    const { t, i18n } = useTranslation();
    const totalPages = orderData?.data?.paginationInfo.totalPagesCount;
    const dataRequests = orderData?.data?.result;

    moment.locale('en');

    //Search Query filtering 
    const filteredReqestsData = orderData?.data?.result.filter(data =>
        data.service.toLowerCase().includes(searchQuery.toLowerCase()) ||
        data.status.toLowerCase().includes(searchQuery) ||
        data.id.toString().includes(searchQuery) ||
        data.description.toLowerCase().includes(searchQuery)
    );

    if (loading) return <div className="loader" role="status" aria-live="polite" aria-label="Loading"></div>;
    if (!orderData) return <div className="loader" role="status" aria-live="polite" aria-label="Loading"></div>;

    return (

        <div className="container my-3 rounded bg-dark-beige pt-2 pb-3">
            <div className="d-flex flex-wrap justify-content-center">
                {dataRequests.length > 0 &&
                    <div className="d-flex flex-wrap flex-sm-nowrap justify-content-between align-items-center col">
                        <SearchInput
                            searchQuery={searchQuery}
                            setSearchQuery={setSearchQuery}
                        />
                        <ItemsToShow
                            setItemsLimit={setItemsLimit}
                            itemsLimit={itemsLimit}
                        />
                    </div>
                }

                <div className="container mt-3 rounded bg-light-gray position-relative p-3 overflow-auto">
                    {dataRequests.length > 0 ?
                        <table className="table table-hover p-2">
                            <thead className="table-dark">
                                <tr className="align-middle">
                                    <th scope="col" className="">{t("Code")}</th>
                                    <th scope="col">{t("Date")}</th>
                                    <th scope="col">{t("Details")}</th>
                                    <th scope="col" className="">{t("OrderStatus")}</th>
                                    <th scope="col" className="text-center">{t("TimerRemaining")}</th>
                                </tr>

                            </thead>
                            <tbody className="align-middle">
                                {(searchQuery ? filteredReqestsData : dataRequests).map((request, index) => (
                                    <Requests
                                        key={index}
                                        orderId={request.id}
                                        serviceName={
                                            allServicesCategories.map(cat => cat.en === request.service ?
                                                (i18n.language === "ar" ? cat.ar : cat.en) : "")}
                                        orderCreated={request.createdAt}
                                        orderTimerCreated={request.createdAt}
                                        orderUpdated={request.updatedAt}
                                        orderDataStatus={request.status}
                                        orderStatus={allStatusListItems.map(state => state.en === request.status ?
                                            (i18n.language === "ar" ? state.ar : state.en) : "")}
                                        numberOfForms={request.numberOfForms}
                                        language={request.language}
                                        orderDescription={request.description}

                                        subServices={request.subServices &&
                                            request.subServices.map((e, index) => {
                                                const matchedSubService = allSubServices.find(subServ => subServ.en === e);
                                                return matchedSubService ? (index > 0 ? " - " : "") + (i18n.language === "ar" ? matchedSubService.ar : matchedSubService.en) : "";
                                            }).filter(Boolean) // This removes any empty strings
                                        }

                                        offerFile={request.offerDetails?.file}
                                        offerPrice={request.offerDetails?.price}
                                        offerNote={request.offerDetails?.notes}
                                        customerFile={request.file}
                                    />

                                ))}
                            </tbody>
                        </table>
                        :
                        <p className="text-center mt-2">{t("NoOrders")}</p>
                    }
                </div>
                {totalPages > 1 &&
                    <Pagination
                        currentPage={currentPage}
                        setCurrentPage={setCurrentPage}
                        totalPages={totalPages} />
                }

            </div>
        </div>
    )
};

